import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Paper,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Button
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { commandsReport } from '../../exportCommands/exportCommandsActions';
import EnhancedTableHead from './EnhancedTableHead';
import ReceptionsTableLoader from './ReceptionsTableLoader';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3)
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: 'auto'
  }
});

/**
 * Tableau d'affichage des batches présent dans une opération
 *
 * @param {Object}   classes                      classes style
 * @param {Object} customerOperation            Object contenant le détail de l'opération dont les batches associés
 * @param {Boolean}  loading                      Indique si les requêtes sont terminées
 */
const EnhancedTable = ({
  classes,
  customerOperation,
  loadingOperation,
  dispatchCommandsReport,
  exportOperation
}) => {
  /**
   * Création de l'objet data permettant de
   * récupéré le fichier d'export
   */
  const handleClick = batche => {
    dispatchCommandsReport({
      operationNumber: customerOperation.id,
      operationBatchDate: batche.date
    });
  };

  return (
    <div>
      <Paper className={classes.root}>
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead loading={loadingOperation} />
            {loadingOperation ? (
              <ReceptionsTableLoader />
            ) : (
              <TableBody>
                <TableRow hover style={{ cursor: 'pointer' }}>
                  <TableCell align="left">
                    <b>Total</b>
                  </TableCell>
                  <TableCell align="left">
                    <b>{customerOperation.todoQuantity}</b>
                  </TableCell>
                  <TableCell align="left">
                    <b>{customerOperation.toShipQuantity}</b>
                  </TableCell>
                  <TableCell align="left">
                    <b>{customerOperation.shippedQuantity}</b>
                  </TableCell>
                  <TableCell align="left">
                    <b>{customerOperation.totalQuantity}</b>
                  </TableCell>
                  <TableCell align="left">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={exportOperation}
                    >
                      Exporter
                    </Button>
                  </TableCell>
                </TableRow>
                {customerOperation.batches.map((batche, index) => (
                  <TableRow
                    hover
                    style={{ cursor: 'pointer' }}
                    tabIndex={-1}
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                  >
                    <TableCell align="left">
                      {batche.date
                        ? moment(batche.date).format('DD/MM/YYYY')
                        : null}
                    </TableCell>
                    <TableCell align="left">{batche.todoQuantity}</TableCell>
                    <TableCell align="left">{batche.toShipQuantity}</TableCell>
                    <TableCell align="left">{batche.shippedQuantity}</TableCell>
                    <TableCell align="left">{batche.totalQuantity}</TableCell>
                    <TableCell align="left">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleClick(batche)}
                      >
                        Exporter
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </div>
      </Paper>
    </div>
  );
};

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
  customerOperation: PropTypes.object.isRequired,
  dispatchCommandsReport: PropTypes.func.isRequired,
  loadingOperation: PropTypes.bool.isRequired,
  exportOperation: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  dispatchCommandsReport: data => dispatch(commandsReport(data))
});

const mapStateToProps = state => ({
  loadingOperation: state.operations.loadingOperation,
  customerOperation: state.operations.customerOperation
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EnhancedTable));
